import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

function AuthGuardRedirect({ children }) {
  const { user } = useSelector((state) => state.account);
  const history = useHistory();

  useEffect(() => {
    const redirects = {};
    if (redirects[user.role]) history.replace(redirects[user.role]);
  }, [user.role, history]);

  return children;
}

export default AuthGuardRedirect;
